import React from 'react'

import { PageLayout, YTDChartWidget, YTDHistoryWidget } from '../..'
import { USERS_WITHOUT_ACCESS } from '../../../constants/access'

class YTDPage extends React.Component {
  render() {
    const hasAccess = (ctx) => {
      if (USERS_WITHOUT_ACCESS.includes(+ctx.user.id_employee)) return false
      return true
    }

    return (
      <PageLayout hasAccess={hasAccess}>
        <div className="row">
          <div className="col-12 mb-2">
            <YTDChartWidget />
          </div>
          <div className="col-12 mb-2">
            <YTDHistoryWidget />
          </div>
        </div>
      </PageLayout>
    )
  }
}

export default YTDPage
